import { FormatColorFillIcon } from './FormatColorFillIcon';

/**
 * author: Google
 * id C4E2DE69-EC92-490F-814A-5D8A20E7E595
 * name format-color-fill
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-color-fill.svg
 * tags
 * - Text / Content / Format 
 * - Color 
 */
export const PaintIcon = FormatColorFillIcon;
export default PaintIcon